(() => {
  const academy = document.querySelector('[data-academy]');
  const root = academy?.querySelector('[data-course-kit-source]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';
  const courses = JSON.parse(academy.querySelector('[data-catalog]').textContent).courses;
  const courseIds = new Set(courses.map(course => course.id));
  const storageKey = '52kards.course-signin-source';
  const sourceKey = 'k52_signup_source';
  const courseKey = 'k52_course';
  const maxAge = 60 * 60 * 1000;
  const accountPaths = new Set(['/account', '/account/login', '/customer_authentication/login']);
  const courseForRoute = route => {
    const match = /^#course\/([a-z0-9-]+)(?:\/lesson\/([a-z0-9-]+))?$/.exec(route || '');
    const course = match && courses.find(item => item.id === match[1]);
    if (!course || match[2] && !course.modules.some(module => module.lessons.some(lesson => lesson.id === match[2]))) return null;
    return course.id;
  };
  const returnUrl = route => {
    const id = courseForRoute(route);
    if (!id) return null;
    const url = new URL(academy.dataset.portalPath, window.location.origin);
    if (academy.dataset.previewThemeId) url.searchParams.set('preview_theme_id', academy.dataset.previewThemeId);
    url.searchParams.set('academy_return', route.slice(1));
    url.searchParams.set(sourceKey, 'course');
    url.searchParams.set(courseKey, id);
    url.hash = route;
    return url;
  };
  const remember = url => {
    try {
      localStorage.setItem(storageKey, JSON.stringify({ course: url.searchParams.get(courseKey), path: url.pathname, startedAt: Date.now() }));
    } catch (_) {}
  };
  const synchronizeAccountLinks = () => {
    if (root.dataset.signedIn === 'true') return;
    document.querySelectorAll('a[href]').forEach(link => {
      if (link.hasAttribute('data-academy-no-marketing-source')) return;
      const account = new URL(link.dataset.courseOriginalHref || link.href, window.location.origin);
      if (account.origin !== window.location.origin || !accountPaths.has(account.pathname)) return;
      const destination = returnUrl(link.dataset.returnRoute || window.location.hash);
      if (!link.hasAttribute('data-course-original-href')) link.dataset.courseOriginalHref = link.href;
      if (!destination) {
        if (!link.hasAttribute('data-course-login')) link.href = link.dataset.courseOriginalHref;
        return;
      }
      const login = new URL(academy.dataset.loginUrl, window.location.origin);
      login.searchParams.set('return_to', destination.pathname + destination.search + destination.hash);
      link.href = login.href;
      link.setAttribute('data-no-instant', '');
    });
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || root.dataset.signedIn === 'true') return;
    if (link.hasAttribute('data-academy-no-marketing-source')) return;
    const account = new URL(link.href, window.location.origin);
    if (account.origin !== window.location.origin || !accountPaths.has(account.pathname)) return;
    const destination = returnUrl(link.dataset.returnRoute || window.location.hash);
    if (!destination) return;
    account.searchParams.set('return_to', destination.pathname + destination.search + destination.hash);
    link.href = account.href;
    remember(destination);
  }, true);
  academy.querySelector('#AcademyNewsletter')?.addEventListener('submit', event => {
    const destination = returnUrl(window.location.hash);
    if (!destination) return;
    remember(destination);
    const input = event.target.querySelector('input[name="return_to"]');
    if (input) input.value = destination.pathname + destination.search + destination.hash;
  });
  window.addEventListener('hashchange', synchronizeAccountLinks);
  synchronizeAccountLinks();
  const url = new URL(window.location.href);
  if (url.searchParams.get(sourceKey) !== 'course') return;
  const course = url.searchParams.get(courseKey);
  const returnedRoute = window.location.hash || '#' + (url.searchParams.get('academy_return') || '');
  if (!courseIds.has(course) || courseForRoute(returnedRoute) !== course) return;
  let pending;
  try { pending = JSON.parse(localStorage.getItem(storageKey) || 'null'); } catch (_) { return; }
  const age = pending ? Date.now() - pending.startedAt : Infinity;
  if (!pending || pending.course !== course || pending.path !== url.pathname || !Number.isFinite(age) || age < 0 || age > maxAge) return;
  if (root.dataset.signedIn !== 'true') return;
  const consume = () => {
    try { localStorage.removeItem(storageKey); } catch (_) {}
    const clean = new URL(window.location.href);
    clean.searchParams.delete(sourceKey);
    clean.searchParams.delete(courseKey);
    window.history.replaceState(window.history.state, '', clean);
  };
  if (root.dataset.marketing !== 'true') {
    root.dataset.status = 'no-consent';
    consume();
    return;
  }
  const form = root.querySelector(`[data-course-kit-form="${course}"]`);
  if (!form) return;
  const error = root.querySelector('[data-course-kit-error]');
  const retry = root.querySelector('[data-course-kit-retry]');
  let sending = false;
  let completed = false;
  const enroll = async () => {
    if (sending || completed) return;
    sending = true;
    root.dataset.status = 'sending';
    error.hidden = true;
    retry.hidden = true;
    try {
      const body = new FormData(form);
      body.append('host', window.location.href);
      body.append('referrer', document.referrer);
      body.append('search', window.location.search);
      body.append('ckjs_version', '6');
      const response = await fetch(form.action, { method: 'POST', body, keepalive: true, headers: { Accept: 'application/json', 'X-CKJS-Version': '6' }, signal: AbortSignal.timeout(15000) });
      if (!response.ok || (await response.json()).status !== 'success') throw new Error('Enrollment not accepted');
      completed = true;
      root.dataset.status = 'subscribed';
      consume();
    } catch (_) {
      root.dataset.status = 'retry';
      error.hidden = false;
      retry.hidden = false;
    } finally {
      sending = false;
    }
  };
  retry.addEventListener('click', enroll);
  enroll();
})();
